enum TextEnum {
	requis = 'Champ requis'
}

export default TextEnum